import { getRequest } from 'utils/api/apiRequest'
import { CatalogProduct } from 'utils/api/Products/CatalogProduct'

export const fetchProduct = (id: number) => getRequest<CatalogProduct>(`/redemption-site/products/${id}`)
